import { useEffect, useState } from "react";
export const usePlatformDetector = () => {
    const [platform, setPlatform] = useState("web");
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor;
        if (/iPad|iPhone|iPod/.test(userAgent)) {
            setPlatform("ios");
        }
        else if (/android/i.test(userAgent)) {
            setPlatform("android");
        }
        else {
            setPlatform("web");
        }
    }, []);
    return platform;
};
//# sourceMappingURL=usePlatformDetector.js.map